import React from "react";
import styled from "@emotion/styled";
import { Link } from "gatsby";

const ActionsContainer = styled.div`
  display: flex;
  border-radius: 5px;
  background-color: #0088d2;
  text-align: center;
  width: 100%;
  margin-bottom: 15px;

  a {
    padding: 18px;
    flex-grow: 1;
    flex-basis: 0;
    font-family: "Gilroy";
    font-weight: bold;
    color: #fff;
  }
  a.barcode {
    background-color: #0095e6;
  }
`;

const MapsIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C11.065 0 7.5 3.19125 7.5 7.1275C7.5 12.98 13.4788 13.5988 15 22.5C16.5212 13.5988 22.5 12.98 22.5 7.1275C22.5 3.19125 18.9363 0 15 0ZM15 10C13.6187 10 12.5 8.88125 12.5 7.5C12.5 6.11875 13.6187 5 15 5C16.3813 5 17.5 6.11875 17.5 7.5C17.5 8.88125 16.3813 10 15 10ZM30 30L21.6162 26.9662L15 30L8.02375 26.9662L0 30L5 18.75L9.95 16.77C10.425 17.415 10.8763 18.12 11.2762 18.9313L6.8725 20.6938L4.71625 25.5437L8.05625 24.2812L9.93875 20.9225L9.145 24.7275L14.3813 26.9637L15 24.4375L15.5813 26.9675L20.7687 24.605L19.9963 20.8137L21.9613 24.4338L25.3763 25.67L23.2025 20.6975L18.7262 18.9287C19.125 18.1162 19.5775 17.41 20.0537 16.765L25.08 18.75L30 30Z"
        fill="white"
      />
    </svg>
  );
};

const BarcodeIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.9215 25.9478V29.5753H29.5489V25.9478H28.3398V24.7387H27.1306V25.9478H25.9215ZM28.3398 27.157V28.3661H27.1306V27.157H28.3398ZM0.529297 29.5753H10.2025V19.9021H0.529297V29.5753ZM1.73845 21.1112H8.99335V28.3661H1.73845V21.1112ZM25.9215 24.7387V23.5295H27.1306V24.7387H25.9215ZM2.9476 22.3204H7.7842V27.157H2.9476V22.3204ZM12.6208 18.6929V21.1112H11.4116V18.6929H12.6208ZM15.0391 9.01972H16.2483V10.2289H15.0391V9.01972ZM16.2483 7.81057H17.4574V9.01972H16.2483V7.81057ZM17.4574 10.2289V9.01972H18.6666V10.2289H17.4574ZM17.4574 7.81057H18.6666V0.555664H15.0391V1.76481H11.4116V2.97396H15.0391V4.18312H17.4574V7.81057ZM16.2483 2.97396V1.76481H17.4574V2.97396H16.2483ZM7.7842 7.81057H2.9476V2.97396H7.7842V7.81057ZM15.0391 7.81057H13.83V5.39227H11.4116V4.18312H15.0391V5.39227H16.2483V6.60142H15.0391V7.81057ZM10.2025 0.555664H0.529297V10.2289H10.2025V0.555664ZM8.99335 9.01972H1.73845V1.76481H8.99335V9.01972ZM12.6208 9.01972H11.4116V7.81057H13.83V10.2289H12.6208V9.01972ZM8.99335 12.6472V13.8563H7.7842V12.6472H8.99335ZM27.1306 19.9021H29.5489V23.5295H28.3398V22.3204H25.9215V23.5295H24.7123V22.3204H23.5032V21.1112H24.7123V19.9021H25.9215V21.1112H27.1306V19.9021ZM22.294 22.3204H21.0849V23.5295H19.8757V22.3204H18.6666V21.1112H19.8757V19.9021H17.4574V18.6929H16.2483V19.9021H15.0391V21.1112H12.6208V22.3204H11.4116V29.5753H17.4574V28.3661H16.2483V25.9478H15.0391V28.3661H12.6208V27.157H13.83V25.9478H12.6208V24.7387H16.2483V23.5295H18.6666V25.9478H17.4574V27.157H18.6666V29.5753H19.8757V27.157H21.0849V28.3661H22.294V27.157H23.5032V24.7387H24.7123V23.5295H22.294V22.3204ZM21.0849 25.9478H19.8757V24.7387H21.0849V25.9478ZM28.3398 18.6929V16.2746H29.5489V18.6929H28.3398ZM17.4574 24.7387V25.9478H16.2483V24.7387H17.4574ZM23.5032 28.3661V27.157H24.7123V29.5753H22.294V28.3661H23.5032ZM19.8757 0.555664V10.2289H29.5489V0.555664H19.8757ZM28.3398 9.01972H21.0849V1.76481H28.3398V9.01972ZM27.1306 7.81057H22.294V2.97396H27.1306V7.81057ZM28.3398 12.6472H29.5489V15.0655H28.3398V16.2746H25.9215V11.438H27.1306V13.8563H28.3398V12.6472ZM23.5032 19.9021V16.2746H24.7123V19.9021H23.5032ZM7.7842 11.438V12.6472H5.3659V13.8563H6.57505V15.0655H2.9476V13.8563H4.15675V12.6472H1.73845V13.8563H0.529297V11.438H7.7842ZM6.57505 16.2746V15.0655H7.7842V18.6929H6.57505V17.4838H5.3659V18.6929H4.15675V17.4838H2.9476V18.6929H0.529297V17.4838H1.73845V16.2746H6.57505ZM1.73845 15.0655V16.2746H0.529297V15.0655H1.73845ZM24.7123 12.6472H23.5032V11.438H24.7123V12.6472ZM8.99335 17.4838H10.2025V18.6929H8.99335V17.4838ZM27.1306 19.9021H25.9215V18.6929H27.1306V19.9021ZM21.0849 21.1112V19.9021H22.294V21.1112H21.0849ZM19.8757 19.9021H21.0849V16.2746H23.5032V15.0655H24.7123V13.8563H23.5032V12.6472H21.0849V11.438H19.8757V12.6472H18.6666V11.438H17.4574V12.6472H16.2483V11.438H15.0391V12.6472H13.83V13.8563H12.6208V12.6472H13.83V11.438H8.99335V12.6472H11.4116V13.8563H8.99335V15.0655H10.2025V17.4838H11.4116V16.2746H13.83V18.6929H15.0391V13.8563H16.2483V16.2746H19.8757V17.4838H17.4574V18.6929H19.8757V19.9021ZM21.0849 13.8563H22.294V15.0655H21.0849V13.8563ZM18.6666 15.0655H17.4574V13.8563H18.6666V15.0655Z"
        fill="white"
      />
    </svg>
  );
};

const HistoryIcon = () => {
  return (
    <svg
      width="29"
      height="30"
      viewBox="0 0 29 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29 15C29 23.2837 22.5076 30 14.5 30C6.49238 30 0 23.2837 0 15H2.41667C2.41667 21.8925 7.83725 27.5 14.5 27.5C21.1628 27.5 26.5833 21.8925 26.5833 15C26.5833 8.1075 21.1628 2.5 14.5 2.5C11.1445 2.5 8.11154 3.92625 5.92204 6.22125L8.41242 8.7975L0 10.49L1.57687 1.72375L4.20983 4.44875C6.83433 1.70375 10.4714 0 14.5 0C22.5076 0 29 6.71625 29 15ZM13.2917 7.5V17.5H21.75V15H15.7083V7.5H13.2917Z"
        fill="white"
      />
    </svg>
  );
};

export default function PlaygroundActions() {
  return (
    <ActionsContainer>
      <a href="https://drive.google.com/open?id=10jQEHshnWzbm6y95fAZKvR-JVbBzRAJM">
        <MapsIcon />
        <div>View map</div>
      </a>
      <Link to="/play/id" className="barcode">
        <BarcodeIcon />
        <div>Play ID</div>
      </Link>
      <Link to="/play/history">
        <HistoryIcon />
        <div>History</div>
      </Link>
    </ActionsContainer>
  );
}
